/* eslint-disable no-undef */
import React from 'react';
import { Styles } from './style';
import { useLocation, Link } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import { ALL_MENUS, AuthenticatedTabs } from '@utils/constants';
import { useUserStore } from '@stores/User/User';

interface MenuItemProps {
  to: string;
  label: string;
}
const MenuItem: React.FC<MenuItemProps> = ({ to, label }) => {
  const location = useLocation();
  const isActive = location.pathname.includes(to);

  return (
    <Link to={to} style={{ textDecoration: 'none' }} reloadDocument>
      {isActive ? (
        <Styles.ActiveMenuItem>{label}</Styles.ActiveMenuItem>
      ) : (
        <Styles.MenuItem>{label}</Styles.MenuItem>
      )}
    </Link>
  );
};

interface SideMenuProps {
  selectedTab: AuthenticatedTabs;
}

function SideMenu({ selectedTab }: SideMenuProps) {
  const { role } = useUserStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const currentMenu = ALL_MENUS[selectedTab] || [];

  // const navigate = useNavigate();
  // const [currentMenu, setCurrentMenu] = useState<
  //   { to: string; label: string }[]
  // >(ALL_MENUS[selectedTab] || []);

  // const handleSpecialMenuItemClick = (route: string) => {
  //   navigate(route);
  // };

  // useEffect(() => {
  //   setCurrentMenu(ALL_MENUS[selectedTab] || []);
  // }, [selectedTab]);

  if (isMobile) {
    return null;
  }

  return (
    <Styles.SideMenu isMobile={isMobile}>
      {/* 👈 Renderiza os links dinamicamente com base na categoria */}
      <Styles.Section>
        {currentMenu.map(
          (item) =>
            role &&
            item.access.includes(role) && (
              <MenuItem key={item.to} to={item.to} label={item.label} />
            )
        )}
      </Styles.Section>
      {/* Opcional: Renderizar menus fixos (não relacionados às abas) */}
      <Styles.Section>
        {/*
        <Styles.SpecialMenuItem
          onClick={() => {
            // Lógica para navegação
          }}>
          <Styles.Icon src={House} alt="House Icon" /> CLIENTES
        </Styles.SpecialMenuItem>
        <MenuItem to="/area-do-corretor/clientes/contato" label="Contato" />
        <MenuItem
          to="/area-do-corretor/clientes/cadastre-seu-imovel"
          label="Cadastre Seu Imóvel"
        />
        <MenuItem
          to="/area-do-corretor/clientes/encomende-seu-imovel"
          label="Encomende Seu Imóvel"
        />
      </Styles.Section>
      <Styles.Section>
        <Styles.SpecialMenuItem
          onClick={() => {
            // Lógica para navegação
          }}>
          <Styles.Icon src={House} alt="House Icon" /> USUARIOS
        </Styles.SpecialMenuItem>
        <MenuItem to="/area-do-corretor/usuarios/listagem" label="Listagem" />
        */}
      </Styles.Section>
    </Styles.SideMenu>
  );
}

export default SideMenu;
